import { FocusRing } from '@react-aria/focus';
import * as React from 'react';
import S from './LocationTabButton.styles';
import { getRetinaSrcs, imageUrl } from '@helpers/image';
const LocationTabButton = ({ children, theme = 'outline', avatar, location, name, variant = 'default', ...otherProps }) => {
    return (React.createElement(FocusRing, { focusRingClass: "focus-ring" },
        React.createElement(S.Container, { ...otherProps, "data-theme": theme, "data-variant": variant },
            React.createElement(S.AvatarWrapper, null, avatar && (React.createElement(S.Avatar, { alt: "", loading: "lazy", role: "presentation", src: imageUrl(avatar, { width: 100, heightratio: 1 }), srcSet: getRetinaSrcs(avatar, 100, 1).join(','), width: "100", height: "100" }))),
            React.createElement(S.ContentContainer, null,
                React.createElement(S.ContentName, null, name),
                React.createElement(S.ContentLocation, null, location)))));
};
export default LocationTabButton;
